if (!customElements.get('pdp-comparison')) {
  customElements.define(
    'pdp-comparison',
    class PdpComparison extends HTMLElement {
      constructor() {
        super();
        this._onCurrencyChange = this.formatPrices.bind(this);
      }

      connectedCallback() {
        this.priceEls = this.querySelectorAll('[data-price-eur]');
        this.formatPrices();
        ['currency:change', 'currency:changed', 'shopify:currency:change'].forEach((evt) => {
          document.addEventListener(evt, this._onCurrencyChange);
        });
      }

      disconnectedCallback() {
        ['currency:change', 'currency:changed', 'shopify:currency:change'].forEach((evt) => {
          document.removeEventListener(evt, this._onCurrencyChange);
        });
      }

      getCurrency() {
        return window.Shopify?.currency?.active || 'EUR';
      }

      getRate() {
        const rate = parseFloat(window.Shopify?.currency?.rate);
        return isNaN(rate) ? 1 : rate;
      }

      formatMoney(amount, currency) {
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
        } catch (e) {
          return amount.toFixed(2);
        }
      }

      // Per-currency anchor for the active currency. Falls back to EUR × rate
      // if no anchor exists for the active market, so unknown currencies still
      // render a sensible value.
      getValue(el, suffix) {
        const currency = this.getCurrency();
        const key = 'price' + suffix + currency.charAt(0).toUpperCase() + currency.slice(1).toLowerCase();
        const direct = parseFloat(el.dataset[key]);
        if (!isNaN(direct) && direct > 0) return direct;
        const eurKey = 'price' + suffix + 'Eur';
        const eur = parseFloat(el.dataset[eurKey]);
        if (isNaN(eur) || eur === 0) return null;
        return eur * this.getRate();
      }

      formatPrices() {
        const currency = this.getCurrency();
        this.priceEls.forEach((el) => {
          const minVal = this.getValue(el, '');
          if (minVal === null) return;
          const maxVal = this.getValue(el, 'Max');
          const prefix = el.dataset.pricePrefix || '';
          const suffix = el.dataset.priceSuffix || '';
          const separator = el.dataset.priceSeparator || '– ';
          let next = prefix + this.formatMoney(minVal, currency);
          if (maxVal !== null) {
            next += separator + this.formatMoney(maxVal, currency);
          }
          next += suffix;
          if (el.textContent !== next) el.textContent = next;
        });
      }
    }
  );
}
